module.exports = __webpack_public_path__ + "img/oki1.1641a4b9.png";